<script setup lang="ts"></script>

<template>
  <div class="">
    <header>Header private</header>
    <slot />
  </div>
</template>
